<template>
    <div class="mb-4 jewelry_block col-lg-3 col-md-4 col-6" :class="{ 'col-lg-12 col-md-12 col-12 list_view mob-list-view-spacing' :viewType === 'list'}">
        <div class="" v-if="data.key === 'empty_state'">
            <img src="@/assets/assets/skeleton.jpg" width="600" height="600" alt="loading skeleton">
            <p class="placeholder-glow mb-0 mt-2">
                <span class="placeholder col-12 p-3"></span>
                <span class="placeholder col-6 p-2 my-2"></span>
            </p>
            <p class="placeholder-glow mb-0">
                <span class="placeholder col-1 p-3 me-1"></span>
                <span class="placeholder col-1 p-3 me-1"></span>
                <span class="placeholder col-1 p-3 me-1"></span>
            </p>
        </div>
        <div class="product_box" v-if="currentMetal">
            <!-- discount_label -->
            <div class="disc_chip_plp" v-if="!$country.is_india && activeShape.discount_label">{{ activeShape.discount_label }}% OFF</div>
            <div class="product-sku"> {{data.main_sku}} </div>
            <div v-if="getUrl" class="mob_mod">
                
                <router-link :to="getUrl" class="on_hover">
                    <img loading="lazy" v-if="!loader&&frontImage" width="246" class="front_img" height="246" :alt="data.product_name + ' front view'" :src="frontImage">
                    <img loading="lazy" v-else width="246" class="loader_img" height="246" alt="loader" src="~/assets/assets/loader.svg">
                    <img loading="lazy"  width="246" class="left_img mx-auto" height="246" :alt="data.product_name + ' left view'" :src="currentMetal.images.left">
                </router-link>
                <h5 :class="{'show':data.has_accent_stones === 1}" class="mb-0">Hidden Accents</h5>
                <router-link :to="getUrl" class="on_hover">
                    <h3>{{data.product_name}}</h3>
                </router-link>
            </div>
            <!-- mb-3 -->
             <!-- :class="{'mb-0 price-min-height': !$country.is_india}" -->
            <h4  class="mb-3" v-if="activeShape">{{ $formatPrice(activeShape.price) }}
                <!-- <span class="india_price" v-if="$country.location == 'IN'">{{ $formatPrice( activeShape.mrp ) }}</span> -->
                 
                <!-- discount_label && lowest_price_label -->
                <span class="us_price" v-if="!$country.is_india && activeShape?.discount_label">{{ $formatPrice( activeShape.mrp ) }}</span>  
                <!-- lowest_price_label  -->
                <span v-if="!$country.is_india && activeShape?.lowest_price_label && activeShape?.discount_label" class="lowest_price_plp mt-2">Lowest Price Ever</span>
            </h4>
          
            <div class="metal_color d-flex mb-2 pb-1 align-items-center">
                <div 
                    v-for="metal in metalList" 
                    :key="metal.slug"
                    class="metal_box"
                    @click="selectMetal(metal.metal)"
                    :class="{ 
                        'white': (metal.metal === 4 || metal.metal === 7 || metal.metal === 10 ), 
                        'yellow': (metal.metal === 5 || metal.metal === 8), 
                        'rose': (metal.metal === 6 || metal.metal === 9),
                        'active': metal.selected === 1
                    }">
                    <!-- {{ metal.short_label }} -->
                </div>
            </div>
            <div class="carat_list_block shape_list_block mt-3" ref="scrollContainer">
                <div v-if="shapesArray" class="shape_list" ref="scrollContainer">
                    <div 
                        class="shape_box" 
                        v-for="item in shapesArray" 
                        :key="item.shape"
                        @click="selectShape(item.shape)"
                    >
                        <SvgShapeSvg v-if="item.selected === 1" :type="item.shape + '_active_green'" />
                        <SvgShapeSvg v-else :type="item.shape" />
                    </div>
                </div>
            </div>
            <!-- <p v-show="data.matchingBand === 1" class="mt-1 mb-0">Matching band available</p> -->
        </div>
    </div>   
</template>

<script setup>

    const { data, viewType } = defineProps(['data', 'viewType'])
    const route = useRoute();
    const moduleSubType = route.meta.moduleSubType 
    const localePath = useLocalePath()
    const { $formatPrice, $country } = useNuxtApp()

    const loader = ref(false)
    const active_shape = ref(false)
    const front_image = ref(false)
    const scrollContainer = ref('')
    const startX = ref(0);
    const isDown = ref(false)
    const scrollLeft = ref(0);

    import { cyolistStore }  from '@/stores/cyolist/cyolist';
    const store = cyolistStore();

    const selectedMetal = computed(() =>{
        const metalList = store.getSettingFilterOptions( moduleSubType , 'metal' )
        if( metalList && metalList.length > 0){
            return metalList.find( (cv)=>  { return cv.active === 1  })
        }
        return false
    })

    const metalList = computed(() => {
        if(selectedMetal.value){
            if(selectedMetal.value.short_label === '18K'){
                return data.metals.filter(list => list.short_label === '18k')
            }
            else if(selectedMetal.value.short_label === 'PT'){
                return data.metals.filter(list => list.short_label === 'pt')
            }
            else{
                return data.metals.filter(list => list.short_label === '14k')
            }
        }
        return data.metals.filter(list => list.short_label === '14k')
    })

    const currentMetal = computed(() => {
        if(data.metals){

            return data.metals.find((item) => item.selected === 1)
        }
        return null 
    })

    const shapesArray = computed(() => {
        if( currentMetal.value && currentMetal.value.diamonds ){

            return currentMetal.value.diamonds
        }
        return null
    })

    const activeShape = computed(() => {
        
        if( currentMetal.value && currentMetal.value.diamonds ){

            return currentMetal.value.diamonds.find((item) => item.selected === 1) 
        }
        return null
    })

    const frontImage = computed(() => {

        if( data.all_images && data.all_images.length > 0 ){
            const imageArray = data.all_images.find( (image) => image.color === currentMetal.value.icon )
            if( imageArray.shapes && imageArray.shapes[activeShape.value.shape  ]  ){

                front_image.value = imageArray.shapes[activeShape.value.shape  ]
            }
        }

        return front_image.value ?? null
    })

    const getUrl = computed(() => {

        if( currentMetal.value && currentMetal.value.slug && currentMetal.value.id && activeShape.value ){

            const slug = currentMetal.value.slug.substring(0, currentMetal.value.slug.lastIndexOf('-'));
            return localePath({path: '/preset-engagement-rings/'+slug+'-'+currentMetal.value.id+'D'+activeShape.value.id}) 
        }

        return null
    })
    
    function selectMetal(metal) {

        loader.value = true;

        const active_shape = activeShape.value

        data.metals.map( (item) => item.metal === metal ? (item.selected = 1) : (item.selected = 0)  )

        if( activeShape ){

            selectShape( active_shape.shape )
        }

        setTimeout( () => loader.value = false,  700);
    }

    function selectShape(shape){

        const metal = data.metals.find( (item) => item.selected === 1 )
        if(metal.diamonds ){

            metal.diamonds.map( (cv) => cv.shape === shape ? cv.selected = 1 : cv.selected = 0 )
        }
    }

    function initHorizontalScroll() {
        if(scrollContainer.value){
            const scroll_Container = scrollContainer.value;

            scroll_Container.addEventListener('mousedown', (e) => {
                isDown.value = true;
                startX.value = e.pageX - scroll_Container.offsetLeft;
                scrollLeft.value = scroll_Container.scrollLeft;
            });

            scroll_Container.addEventListener('mouseleave', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mouseup', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mousemove', (e) => {
                if (!isDown.value) return;
                e.preventDefault();
                const x = e.pageX - scroll_Container.offsetLeft;
                const walk = (x - startX.value) * 3; // Adjust scrolling speed here
                scroll_Container.scrollLeft = scrollLeft.value - walk;
            });
        }
    }

    onMounted(() => {
        initHorizontalScroll();   
        
        if( typeof cls_InovaDiamonds_Iframe !== 'undefined' && cls_InovaDiamonds_Iframe.init_Session_Go !== undefined ){
            cls_InovaDiamonds_Iframe.init_Session_Go()
        }

        const script = document.createElement('script');
        script.src = 'https://vto.jewelry/?d=6LYC9UW';
        script.async = true;
        script.onload = () => {
        };
        document.head.appendChild(script);
    })
        
</script>

<style scoped>
.product-sku {
    display: none;
}
.carat_label {
    font-size: 14px;
    color: #909090;
}
.empty_box {
    height: 73px;
}
.metal_box.active {
    pointer-events: none;
}
.left_img{
    display: none;
}
.front_img{
    display: block;
}
.loader_img{
    display: block;
}
.on_hover:hover .left_img{
    display:block
}
.on_hover:hover .front_img{
    display:none
}
.product_box {
    padding: 15px;
    border: 1px solid #eaeaea;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
}
.product_box:hover{
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.15);

}
a{
    display: inline-block;
    color: #000;
}
h3 {
    font-size: 16px;
    font-weight: normal;
    line-height: 1.5;
    min-height: 50px;
    color: #353535;
}
h4 {
    font-size: 18px;
    font-weight: 600;
    color: #668b84;
}

h4.price-min-height{
    min-height: 45px;
}

h4 span.us_price {
    color: #656565;
    text-decoration: line-through;
    font-weight: 400;
    font-size: 14px;
}
h4 span.india_price {
    color: #656565;
    text-decoration: line-through;
    font-weight: 400;
    font-size: 14px;
    display: block;
    margin-top: 5px;
    
}
.metal_color .metal_box {
    height: 20px;
    width: 20px;
    /* margin-right: 5px; */
    cursor: pointer;
    /* border: 2px solid #fff; */
    border-radius: 2px;
}

.metal_box_mod{
    height: 32px !important;
    width: 32px !important;
    margin-right: 7px;
    cursor: pointer;
    border: 1px solid #fff;
    font-size: 11px;
    /* font-weight: 800; */
    display: flex;
    align-items: center;
    justify-content: center;
    color: #505050;
    letter-spacing: 0.5px;
}
.metal_color .metal_box.active {
    height: 22px;
    width: 22px;
    border: 1px solid #000;
}
.metal_color {
    gap: 8px;
}
.metal_color .yellow {
    background: #f3dda1;
}
.metal_color .rose {
    background: #f3b089;
}
.metal_color .white, .metal_color .platinum {
    background: #eff0f0;
}
p {
    color: #656565;
    font-size: 16px;
    font-weight: 300;
}
h5 {
    /* background: #f2f2f2;
    color: #656565;
    font-size: 13px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    padding: 4px 8px;
    position: absolute;
    top: 5px;
    left: 5px; */
    text-align: center;
    font-size: 12px;
    color: #909090;
    height: 20px;
    visibility: hidden;
}

h5.show{
    visibility: visible;
}
.carat_list, .shape_list {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
}
.shape_box {
    /* margin-right: 12px; */
    cursor: pointer;
}
.carat_box {
    background: #f5f5f5;
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 7px;
    font-size: 11px;
    border: 1px solid #f5f5f5;
    cursor: pointer;
}
.carat_list .carat_box:last-child {
    margin-right: 1px;
}
.carat_box.active {
    border: 1px solid #606060;
}
.carat_list_block {
    overflow-x: scroll;
    overflow-y: hidden;
    padding-bottom: 3px;
    height: 48px;
}
.carat_list_block.shape_list_block {
    height: 40px;
}
/* width */
.carat_list_block::-webkit-scrollbar {
  width: 2px;
  height: 3px;
}

/* Track */
.carat_list_block::-webkit-scrollbar-track {
  background: #f5f5f5; 
}
 
/* Handle */
.carat_list_block::-webkit-scrollbar-thumb {
  background: #c4c4c4; 
}

/* Handle on hover */
.carat_list_block::-webkit-scrollbar-thumb:hover {
  background: #c4c4c4; 
}
.carat_list, .shape_list {
    width: max-content !important;
}
@media(max-width: 992px){
    .product_box{
        padding: 10px;
    }
   
}
@media(max-width: 767px){
    .list_view a{
        display: block;
    }
    .list_view h3{
        text-align: center;
        min-height: auto;
    }
    .list_view h4{
        text-align: center;
    }
    .list_view .metal_color{
        justify-content: center;
    }
    .list_view .mob_mod{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    }
    .list_view .carat_list_block.shape_list_block {
        display: flex;
        justify-content: center;
    }
    
    .list_view p{
        text-align: center;
    }
    .carat_list_block {
        height: 40px;
    }
    .carat_label{
        font-size: 10px;
    }
    .metal_box_mod{
        font-size: 10px;
        height: 32px !important;
        width: 32px !important;
        margin-right: 5px !important;
    }
    .row .jewelry_block:nth-child(2n+2) {
        /* padding: 0;
        padding-right: 10px;
        padding-left: 5px; */
        padding: 7px 12px 7px 7px;
        /* padding: 7px 12px ; */

    }
    .row .jewelry_block:nth-child(2n+1) {
        /* padding: 0;
        padding-left: 10px;
        padding-right: 5px; */
        padding: 7px 7px 7px 12px;

        /* padding: 7px 12px; */

    }

    .row .jewelry_block.mob-list-view-spacing {
        padding: 7px 12px 7px 12px;
    }

    .jewelry_block {
        margin-bottom: 0px !important;
    }
    h4 {
        font-size: 18px;
        font-weight: 600;
        color: #668b84;
    }
    h3, p {
        font-size: 14px;
     
    }
    .empty_box {
        height: 60px;
    }    

    h5{
        padding: 3px 6px;
        font-size: 10px;
    }
    h4 span {
        font-size: 16px;
    }
    .carat_box {
        height: 32px;
        width: 32px;
        margin-right: 5px;
        font-size: 10px;
    }
}

</style>
